
import { defineComponent, ref } from "vue";
import InputText from "primevue/inputtext";
import axios from "axios";
import Ripple from "primevue/ripple";
import Button from "primevue/button";
import Skeleton from "primevue/skeleton";
import Accordion from "primevue/accordion";
import AccordionTab from "primevue/accordiontab";
import { useRouter, useRoute } from "vue-router";
import Dropdown from "primevue/dropdown";
import Editor from "primevue/editor";
import { useToast } from "primevue/usetoast";
import Toast from "primevue/toast";
import store from "../store";

const axioCred = axios.create({
  withCredentials: true,
});

export default defineComponent({
  name: "Offer",
  components: {
    InputText,
    Button,
    Skeleton,
    Accordion,
    AccordionTab,
    Dropdown,
    Editor,
    Toast,
  },
  props: ["offerId"],
  setup(props) {
    const toast = useToast();
    const showSuccess = () => {
      toast.add({
        severity: "success",
        summary: "Выполнено!",
        detail: "Файлы добавлены",
        life: 3000,
      });
    };
    const isLoading = ref(false);
    const isDocsLoading = ref(false);
    const selectedReason = ref({ name: "" });
    const description = ref("");
    const subIndex = ref([
      0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15,
    ]);
    const reasons = ref([
      { name: "Добровольный возврат" },
      { name: "Отмена или задержка рейса" },
      { name: "Изменение перевозчиком маршрута" },
      { name: "Выполнение рейса не по расписанию" },
      { name: "Не предоставили место на рейсе" },
      { name: "Задержали при досмотре" },
      { name: "Нарушена стыковка" },
      { name: "Болезнь пассажира или члена его семьи" },
      { name: "Необеспечение обслуживания по классу" },
      { name: "Неправильное оформление билета" },
      { name: "Иное" },
    ]);
    const isMailInvalid = ref(false);
    const isPhoneInvalid = ref(false);
    const isReasonInvalid = ref(false);
    const router = useRouter();
    const route = useRoute();
    const passMail = ref("");
    const passPhone = ref("");
    const reason = ref("");
    const loading = ref(false);
    const offer = ref(null);
    const checkedOrder = ref(null);
    const error = ref(null);
    const userDocs = ref(null);
    const files = ref<any | null>(null);
    const wrongFileFormat = ref(false);
    const maxFileCount = ref(false);
    const fileSizeEx = ref(false);
    const checkBeforeSumbit = ref(true);
    const showAttachedFiles = ref(false);
    const adjError = ref(false);
    const allUnchecked = ref(false);
    const getUserOffer = async () => {
      isLoading.value = true;
      try {
        const json = await axioCred.get(
          `https://www.biletdv.ru/customer/IBEServices/GetUserOffer?offerId=${props.offerId}`
        );
        if (json.data) {
          let fetchedOrders = await json.data;

          offer.value = fetchedOrders;
          selectedReason.value.name = fetchedOrders.offer.Description.trim();

          isLoading.value = false;
        } else {
          console.log("error!");
          isLoading.value = false;
        }
        console.log(offer.value);
        
        isLoading.value = false;
      } catch (err) {
        if (err.response.status == 401) {
          store.dispatch("auth/logout");
          router.push("/login");
        }
      }
    };
    const getUserDocs = async () => {
      isDocsLoading.value = true;
      try {
        const json = await axioCred.get(
          `https://www.biletdv.ru/customer/IBEServices/LoadDocuments?offerId=${props.offerId}`
        );
        if (json.data) {
          let fetchedOrders = await json.data;

          userDocs.value = fetchedOrders;

          isDocsLoading.value = false;
        } else {
          console.log("error!");
          isDocsLoading.value = false;
        }
      } catch (err) {
        isDocsLoading.value = false;
        if (err.response.status == 401) {
          store.dispatch("auth/logout");
          router.push("/login");
        }
      }
    };
    const sendAttachment = async () => {
      let bodyFormData = new FormData();
      if (files.value) {
        files.value.files.forEach((el: any) => {
          bodyFormData.append(el.name, el, el.name);
        });
      }
      if (maxFileCount.value || fileSizeEx.value || wrongFileFormat.value) {
        return;
      } else {
        loading.value = true;
        try {
          axios({
            method: "POST",
            url: `https://www.biletdv.ru/customer/IBEServices/AddAttachmentToOffer?offerId=${props.offerId}`,
            data: bodyFormData,
            headers: {
              Accept: "application/json",
              "Content-Type": "multipart/form-data",
            },
            withCredentials: true,
          }).then((res) => {
            loading.value = false;
            if (res.status == 200) {
              getUserDocs();
            }
          });
        } catch (err) {
          if (err.response.status == 401) {
            store.dispatch("auth/logout");
            router.push("/login");
          }
        }
      }
    };
    return {
      passMail,
      passPhone,
      reason,
      isLoading,
      isDocsLoading,
      loading,
      offer,
      error,
      checkedOrder,
      router,
      route,
      isMailInvalid,
      isPhoneInvalid,
      isReasonInvalid,
      reasons,
      selectedReason,
      description,
      subIndex,
      files,
      wrongFileFormat,
      maxFileCount,
      fileSizeEx,
      checkBeforeSumbit,
      showAttachedFiles,
      adjError,
      allUnchecked,
      getUserOffer,
      sendAttachment,
      getUserDocs,
      userDocs,
    };
  },
  data() {
    return {
      month: [
        "янв",
        "фев",
        "мар",
        "апр",
        "мая",
        "июн",
        "июл",
        "авг",
        "сен",
        "окт",
        "ноя",
        "дек",
      ],
    };
  },
  methods: {
    handleFileUpload() {
      if (this.files !== null) {
        let filesSize = 0;
        if (this.files.files.length > 0) {
          this.showAttachedFiles = true;
        } else {
          this.showAttachedFiles = false;
        }
        for (let i = 0; i < this.files.length; i++) {
          if (this.files.files[i].size > 10485760) {
            this.fileSizeEx = true;
          } else {
            this.fileSizeEx = false;
          }
          if (
            this.files.files[i].type !== "image/png" &&
            this.files.files[i].type !== "image/jpg" &&
            this.files.files[i].type !== "image/jpeg" &&
            this.files.files[i].type !== "image/pjp" &&
            this.files.files[i].type !== "image/pjpeg" &&
            this.files.files[i].type != "application/pdf" &&
            this.files.files[i].type !== "image/tiff"
          ) {
            console.log("must be true" + this.files.files[i].type);
            this.wrongFileFormat = true;
          } else {
            console.log("must be false" + this.files.files[i].type);
            this.wrongFileFormat = false;
          }

          filesSize += this.files.files[i].size;
        }
        if (filesSize > 22020096) {
          this.fileSizeEx = true;
        } else {
          this.fileSizeEx = false;
        }
        if (this.files.files.length > 10) {
          this.maxFileCount = true;
        } else {
          this.maxFileCount = false;
        }
        if (this.files.files.length == 0) {
          this.wrongFileFormat = false;
        }
        if (this.maxFileCount || this.fileSizeEx || this.wrongFileFormat) {
          this.checkBeforeSumbit = false;
        } else {
          this.checkBeforeSumbit = true;
        }
        console.log(this.files.files[0]);
        console.log(this.wrongFileFormat);
      }
    },
    getWeekDay(date: any) {
      let days = ["вс", "пн", "вт", "ср", "чт", "пт", "сб"];
      let weekDay = new Date(date);
      return days[weekDay.getDay()];
    },
    getDate(date: any) {
      let month = [
        "янв",
        "фев",
        "мар",
        "апр",
        "мая",
        "июн",
        "июл",
        "авг",
        "сен",
        "окт",
        "ноя",
        "дек",
      ];
      let monthNum = new Date(date);
      return monthNum.getDate() + " " + month[monthNum.getMonth()] + " " + monthNum.getFullYear();
    },
    nameCaseChanger(name: string): string {
      let splitedName = name.split(" ");
      let firstLetterUpperCase = "";
      let normalName = "";
      for (let i = 0; i < splitedName.length; i++) {
        firstLetterUpperCase =
          splitedName[i][0].toUpperCase() +
          splitedName[i].slice(1).toLowerCase();
        normalName += firstLetterUpperCase + " ";
      }
      return normalName;
    },
    submitCheck() {
      if (
        this.passMail == "" &&
        this.passPhone == "" &&
        this.selectedReason.name == ""
      ) {
        this.isMailInvalid = true;
        this.isPhoneInvalid = true;
        this.isReasonInvalid = true;
      } else if (this.passMail == "" && this.passPhone == "") {
        this.isMailInvalid = true;
        this.isPhoneInvalid = true;
      } else if (this.passPhone == "" && this.selectedReason.name == "") {
        this.isPhoneInvalid = true;
        this.isReasonInvalid = true;
      } else if (this.passMail == "" && this.selectedReason.name == "") {
        this.isMailInvalid = true;
        this.isReasonInvalid = true;
      } else if (this.passMail == "") {
        this.isMailInvalid = true;
      } else if (this.passPhone == "") {
        this.isPhoneInvalid = true;
      } else if (this.selectedReason.name == "") {
        console.log(this.selectedReason);
        this.isReasonInvalid = true;
      } else {
        this.isMailInvalid = false;
        this.isPhoneInvalid = false;
        this.isReasonInvalid = false;
      }
    },
    getCreatedDate(date: any) {
      function pad(n: any) {
        return n < 10 ? "0" + n : n;
      }
      const now = new Date(date);
      const tz = now.getTimezoneOffset();
      const sign = tz > 0 ? "-" : "+";
      const hours = pad(Math.floor(Math.abs(tz) / 60));
      const minutes = pad(Math.abs(tz) % 60);
      const tzOffset = sign + hours + ":" + minutes;
      const localDateTime =
        now.getFullYear() +
        "-" +
        pad(now.getMonth() + 1) +
        "-" +
        pad(now.getDate()) +
        "T" +
        pad(now.getHours()) +
        ":" +
        pad(now.getMinutes()) +
        ":" +
        pad(now.getSeconds());
      const eventDate = {
        utc: now.toISOString(),
        local: localDateTime,
        tzOffset: tzOffset,
      };

      const localDateString = eventDate.local;
      const localDate = new Date(localDateString);

      let created: any = new Date(localDate);
      if (tz < 0) {
        created.setHours(
          created.getHours() - 10 + Math.floor(Math.abs(tz) / 60)
        );
        created.setMinutes(created.getMinutes() + (Math.abs(tz) % 60));
      } else if (tz > 0) {
        created.setHours(
          created.getHours() - 10 - Math.floor(Math.abs(tz) / 60)
        );
        created.setMinutes(created.getMinutes() - (Math.abs(tz) % 60));
      }

      let createdDay = created.getDate();
      let createdMonth: any = created.getMonth();
      let createdYear = created.getFullYear();
      let createdHours = function () {
        if (created.getHours() < 10) {
          return "0" + created.getHours();
        } else {
          return created.getHours();
        }
      };
      let createdMinutes = function () {
        if (created.getMinutes() < 10) {
          return "0" + created.getMinutes();
        } else {
          return created.getMinutes();
        }
      };

      return (
        createdDay +
        " " +
        this.month[createdMonth] +
        " " +
        createdYear +
        " " +
        createdHours() +
        ":" +
        createdMinutes() +
        " (UTC " +
        tzOffset +
        ")"
      );
    },
    getOfferStatus(num: number) {
      if (num == 10) {
        return "Заявка создана";
      } else if (num == 20) {
        return "Заявка в работе";
      } else if (num == 30) {
        return "Заявка обработана";
      } else if (num == 40) {
        return "Сообщение";
      }
    },
  },
  created() {
    this.getUserOffer();
    this.getUserDocs();
  },
  directives: {
    ripple: Ripple,
  },
});
